<template>
  <div class="form-item">
    <label v-if="label" class="label">{{ label }}</label>

    <select
      class="select-input"
      name="selectInput"
      @change="handleInput"
      :value="value"
      v-if="items && items.length > 0"
    >
      <option disabled selected value="">Please select one</option>
      <option v-for="(item, key) in items" :key="key" :value="item.id">{{
        item.name
      }}</option>
    </select>
    <p v-else>No items found</p>
    <small v-if="error" class="error">{{ error }}</small>
  </div>
</template>

<script>
/* eslint-disable */
// import { mapGetters, mapActions } from "vuex";

export default {
  name: "InputSelect",
  props: {
    model: null,
    placeholder: null,
    label: null,
    disabled: false,
    type: "text",
    items: null,
    error: null,
    value:{},
    command: null,
  },
  computed: {},
  data() {
    return {};
  },
  methods: {
    handleInput(event) {
      this.$emit("input", event.target.value);
      this.command();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/_reduced_variables.scss";
.form-item {
  margin-bottom: 20px;

  .select-input {
    background: #FAFAFA;
    border-radius: 3px;
    border: none;
    width: 100%;
    padding: 10px 20px;
    height: 65px;
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    color: #727272;
  }

  input,
  .input {
    width: 100%;
    display: block;
    border-radius: 3px;
    height: 65px;
    padding: 20px;
    font-weight: bold;
    border: none;
    font-family: 'DM Sans';
    font-style: normal;
    font-size: 16px;
    color: #727272;
    background: #EFEFEF;
  }

  .error {
    color: red;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/components/InputSelect.vue